import { UserRole } from '../services/types';

const ROLE_LEVEL: Record<UserRole, number> = { viewer: 0, supervisor: 1, admin: 2 };

export function isAtLeast(role: UserRole, minimum: UserRole): boolean {
  return ROLE_LEVEL[role] >= ROLE_LEVEL[minimum];
}
